import LocalizedStrings from 'localized-strings';

import { getMobileAppLang } from 'features/Accounting/pages/Estimation/common/utils';

export const locales = new LocalizedStrings(
  {
    en: {
      callout:
        'Estimated amount based on your incoming payments (excluding payments marked as "personal" in the Shine application).',
      complementaryRevenue: 'Including {amount} in supplementary income',
      complementaryRevenueWithVAT:
        'Of which {complementaryRevenue} is supplementary income and {vatAmount} deducted VAT',
      error: 'An error occurred. Please try again.',
      faq: {
        question1: {
          subtitle:
            'Your turnover is estimated based on your incoming payments on the payment date (except for payments marked as “personal” in the Shine application). As a reminder, even if the service or invoicing took place the previous month or quarter, you will only be able to count it in your turnover for the month or quarter in which it was actually paid to you. Thus, a service performed in March, invoiced in April and paid in May will be included in your turnover for the month of May, and not before.',
          title: 'How is my turnover calculated?',
        },
        question2: {
          bic: 'Sale of goods, catering and accommodation (BIC) with contribution rate of 12.3% and reduction of 71% ;',
          bnc: 'Other provision of services and liberal activity (BNC) with contribution rate of 21.1% and reduction of 34% ;',
          craft:
            'Provision of commercial or artisanal services (BIC) with contribution rate of 21.2% and reduction of 50% ;',
          footer:
            'Does your business record several of these types of revenues? You carry out a mixed activity.',
          subtitle:
            'It is possible to carry out several types of activities within the same company, or for the same activity to include several types of income; and therefore several percentages of applicable contributions.\n\nFor example, a plumber who charges for the purchase and installation of a tap carries out a mixed activity. On one side it buys/sells goods (the faucet) and on the other it provides services (installation).  There are three categories with different social security contribution and flat-rate deduction rates:',
          title: 'How do I know if my activity is mixed?',
        },
        title: 'Learn more…',
      },
      form: {
        distributionAmounts:
          'The sum of mixed income must correspond to the turnover provided ({amount} incl. tax).',
        label: {
          bic: 'Amount for commercial or craft services (BIC)',
          bicWithVAT: 'Amount excl. VAT for commercial or craft services (BIC)',
          bnc: 'Amount for other services and self-employed activities (BNC)',
          bncWithVat:
            'Amount excl. VAT for other services and self-employed activities (BNC)',
          complementaryRevenue:
            'Turnover collected excluding Shine account (if applicable)',
          mixActivity: 'My activity is mixed',
          revenue: 'Turnover collected on my Shine account',
          selling:
            'Amount for sales of goods, catering and accommodation (BIC)',
          sellingWithVAT:
            'Amount excl. VAT for sales of goods, catering and accommodation (BIC)',
          vat: 'Total amount of VAT collected over the period',
          vatInfo: 'Learn more about my VAT calculation',
        },
      },
      mixActivity: 'Mixed activity',
      more: 'Learn more',
      revenue: 'Your turnover',
      submit: 'Continue',
      subtitle:
        'Fill in this information to estimate your social security contributions as accurately as possible.',
      title: 'Your situation',
      withoutVat: 'excl. VAT',
      withVatCurrency: '€ incl. VAT',
      withVatSubmit: 'Enter my VAT',
    },
    fr: {
      callout:
        'Montant estimé sur la base de vos paiements entrants (à l’exception des paiements marqués comme “personnels” dans l’application Shine).',
      complementaryRevenue: 'Dont {amount} de complément de revenu',
      complementaryRevenueWithVAT:
        'Dont {complementaryRevenue} de complément de revenu et {vatAmount} de TVA déduite.',
      error: 'Une erreur est survenue. Veuillez réessayer.',
      faq: {
        question1: {
          subtitle:
            'Votre chiffre d’affaires est estimé sur la base de vos paiements entrants à date du versement (à l’exception des paiements marqués comme “personnels” dans l’application Shine).\nPour rappel, même si la prestation ou la facturation a eu lieu le mois ou le trimestre précédent, vous ne pourrez la comptabiliser dans votre chiffre d’affaires que pour le mois ou le trimestre où elle vous a effectivement été réglée. Ainsi, une prestation effectuée en mars, facturée en avril et payée en mai sera à comptabiliser dans votre CA du mois de mai, et pas avant.',
          title: 'Comment est calculé mon chiffre d’affaires ?',
        },
        question2: {
          bic: 'Vente de biens, restauration et hébergement (BIC) avec taux de cotisations à 12,3 % et abattement de 71% ;',
          bnc: 'Autre prestation de services et activité libérale (BNC) avec taux de cotisations à 21,1 % et abattement de 34%  ;',
          craft:
            'Prestation de services commerciale ou artisanale (BIC) avec taux de cotisations à 21,2 % et abattement de 50% ;',
          footer:
            'Votre entreprise enregistre plusieurs de ces types de revenus ? Vous exercez une activité mixte.',
          subtitle:
            'Il est possible d’exercer plusieurs types d’activités au sein d’une même entreprise, ou bien qu’une même activité comporte plusieurs types de revenus ; et donc plusieurs pourcentages de cotisations applicables.\nPar exemple, une plombière qui facture l’achat et la pose d’un robinet exerce une activité mixte. D’un côté elle fait de l’achat / vente de marchandises (le robinet) et de l’autre elle réalise une prestation de services (la pose).\n\nIl existe trois catégories avec des taux de cotisations sociales et d’abattement forfaitaire différents :',
          title: 'Comment savoir si mon activité est mixte ?',
        },
        title: 'En savoir plus…',
      },
      form: {
        distributionAmounts:
          'La somme des revenus mixtes doit correspondre au chiffre d’affaires renseigné ({amount} TTC).',
        label: {
          bic: 'Montant des prestations de services commerciales ou artisanales (BIC)',
          bicWithVAT:
            'Montant HT des prestations de services commerciales ou artisanales (BIC)',
          bnc: 'Montant des autres prestations de services et activités libérales (BNC)',
          bncWithVat:
            'Montant HT des autres prestations de service et activités libérales (BNC)',
          complementaryRevenue:
            'Montant à ajouter ou retirer de mon chiffre d’affaires',
          mixActivity: 'Mon activité est mixte',
          revenue: 'Chiffre d’affaires encaissé sur mon compte Shine',
          selling: 'Montant de vente de biens, restauration, hébergement (BIC)',
          sellingWithVAT:
            'Montant HT de vente de biens, restauration, hébergement (BIC)',
          vat: 'Montant total de TVA encaissé sur la période',
          vatInfo: 'En savoir plus sur le calcul de ma TVA.',
        },
      },
      mixActivity: 'Activité mixte',
      more: 'En savoir plus',
      revenue: 'Chiffre d’affaires TTC',
      submit: 'Continuer',
      subtitle:
        'Vérifiez le montant de votre chiffre d’affaires recensé automatiquement par Shine et ajustez si besoin. Vous pourrez modifier la TVA à la prochaine étape.',
      title: 'Vos revenus',
      withoutVat: 'HT',
      withVatCurrency: '€ TTC',
      withVatSubmit: 'Renseigner ma TVA',
    },
  } as const,
  {
    customLanguageInterface: getMobileAppLang,
  },
);
